module.exports = __webpack_public_path__ + "img/0021.e3d94708.jpg";